import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import Clock from 'shared/ui/icons/General/Clock';
import {UserReportPeriod} from 'features/userReports/model/UserReport/IUserReport';

import styles from './PeriodSelector.module.scss';

interface IPeriodSelectorProps {
    value: UserReportPeriod;
    /* eslint-disable-next-line no-unused-vars */
    onChange: (period: UserReportPeriod) => void;
}

const PeriodSelector: React.FC<IPeriodSelectorProps> = ({value, onChange}) => {
    const options: {value: UserReportPeriod, label: string, timing: string}[] = [
        {value: 'W', label: t`Раз в неделю`, timing: t`Формируется после 00:00 в понедельник`},
        {value: 'M', label: t`Раз в месяц`, timing: t`В 00:00 1-го числа следующего месяца`},
        {value: 'Y', label: t`Раз в год`, timing: t`В 00:00 1 января следующего года`},
    ];

    return (
        <div className={styles.grid}>
            {options.map((option) => (
                <button
                    type="button"
                    key={option.value}
                    className={cn(styles.card, value === option.value && styles.active)}
                    onClick={() => onChange(option.value)}
                    aria-pressed={value === option.value}
                >
                    <span className={styles.icon}><Clock/></span>
                    <span className={styles.label}>{option.label}</span>
                    <span className={styles.timing}>{option.timing}</span>
                </button>
            ))}
        </div>
    );
};

export default PeriodSelector;
